<template>
  <div class="d-flex flex-column justify-center align-center h-100">
    <div
      class="my-auto"
      :style="{ maxWidth: isMobile ? '' : '452px' }"
    >
      <slot name="main" />
      <div
        v-if="!isMobile && $scopedSlots.actions"
        class="text-center"
        :class="{ 'mt-6': $slots.main }"
      >
        <slot
          name="actions"
          :button-props="{
            elevation: 0,
            color: 'primary',
            width: 240,
          }"
        />
      </div>
    </div>
    <div
      v-if="isMobile && $scopedSlots.actions"
      class="w-100"
    >
      <slot
        name="actions"
        :button-props="{
          elevation: 0,
          color: 'primary',
          block: true,
        }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppointmentScreenWrapper',
  data: () => ({
    isMobile: window.MOBILE_VERSION,
  }),
}
</script>
